/**
 * Tłumaczy komunikaty błędów Supabase Auth na polskie komunikaty dla UI.
 * Odrzucenie rejestracji przez trigger (duplikat kanonicznego adresu Gmail)
 * przychodzi z GoTrue jako "Database error saving new user" — mapujemy na
 * generyk bez wskazywania przyczyny (anty-enumeracja adresów).
 */
export function translateAuthError(error: any): string {
  const raw = (error?.message || '').toString()
  if (/email not confirmed/i.test(raw)) {
    return 'Adres e-mail nie został potwierdzony. Sprawdź skrzynkę i kliknij link aktywacyjny.'
  }
  if (/invalid login credentials|invalid email or password/i.test(raw)) {
    return 'Nieprawidłowy e-mail lub hasło.'
  }
  if (/database error saving new user/i.test(raw)) {
    return 'Rejestracja nie powiodła się. Spróbuj ponownie lub skontaktuj się z nami.'
  }
  if (/captcha/i.test(raw)) {
    return 'Weryfikacja antybotowa nie przeszła. Odśwież stronę i spróbuj ponownie.'
  }
  return raw
}
